// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestPendingOutcomeGetBody = {
  poolId: string;
  contestId: string;
};

export type typeContestPendingOutcomeGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    outcomeStatus: "pending";
    tiebreaker: "splitMedal" | "noWinner" | "commissionerPick";
    medalName: string;
    medalsToAssign: number;
    tieExists: boolean;
    winners: { entryId: string; userId: string; displayName: string }[];
    tiedCandidates: { entryId: string; userId: string; displayName: string }[];
    commissionerNamedWinnerIds?: string[] | null;
    commissionerNamedAtMs?: number | null;
    isSeasonLastContest: boolean;
    lateRoundExists: boolean;
    detectedAt: string;
    autoConfirmsAt: string;
    nudgeSentAt?: string | null;
    outstandingRound?: { roundId: string; eventIds: string[] };
    pickemStandings?:
      | {
          entryId: string;
          points: number;
          titles: number;
          wins: number;
          losses: number;
          pushes: number;
          finalRoundGuess?: number | null;
          finalRoundGuessDiff?: number | null;
        }[]
      | null;
  };
};

export type typeContestPendingOutcomeGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestPendingOutcomeGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestPendingOutcomeGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestPendingOutcomeGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestPendingOutcomeGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestPendingOutcomeGetBody);
  }

  return async function postContestPendingOutcomeGet(
    payload: typeContestPendingOutcomeGetBody,
  ): Promise<
    | typeContestPendingOutcomeGetOutput200
    | typeContestPendingOutcomeGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestPendingOutcomeGet" failed before calling the network. #ee7aba264e7d`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#ee7aba264e7d" },
        },
        data: null,
      } as typeContestPendingOutcomeGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/pending-outcome-get`,
      httpMethod: "POST",
      options,
    })) as
      | typeContestPendingOutcomeGetOutput200
      | typeContestPendingOutcomeGetOutput400;
  };
}
